<template>
    <span>
        <v-list-tile @click="$emit('abrirChatMensages')">
            <v-list-tile-title>
                Mensagens
            </v-list-tile-title>
        </v-list-tile>
    </span>
</template>

<script>

export default {
    name: 'AcoesAbrirMensagens',
}
</script>

<style scoped lang="stylus">

</style>